import {
  HubConnectionBuilder,
  HttpTransportType,
  LogLevel,
  HubConnection,
} from "@microsoft/signalr";
import * as Azure from "us.helper/azure";
import { httpCollection } from "us.helper/http/collection";

export default (
  onStart = () => {},
  onError = (error: any) => {},
  onConnect = (connection: HubConnection) => {},
) => {
  negotiate()
    .then((response) => {
      const { accessToken, url } = response.data;
      const currentUser: any = new Azure.ADAuth().currentUser();

      const connection = new HubConnectionBuilder()
        .configureLogging(LogLevel.Information) // 🔥 important
        .withUrl(url, {
          transport: HttpTransportType.WebSockets,
          accessTokenFactory: () => accessToken,
          headers: {
            userid: currentUser?.oid || "",
          },
        })
        .withAutomaticReconnect()
        .build();

      // ✅ GLOBAL LOGS START HERE

      connection.onclose((error) => {
        console.error("❌ SignalR Disconnected", error);
      });

      connection.onreconnecting((error) => {
        console.warn("⚠️ SignalR Reconnecting...", error);
      });

      connection.onreconnected((connectionId) => {
        console.log("🔄 SignalR Reconnected", connectionId);
      });

      // (Optional) log all incoming raw messages
      connection.on("*", (...args: any[]) => {
        console.log("📩 Incoming SignalR event:", args);
      });

      // ❗ Note: '*' only works if you manually wrap events (not native)

      // ✅ START CONNECTION
      connection
        .start()
        .then(() => {
          console.log("✅ SignalR Connected");
          onStart();
          onConnect(connection);
        })
        .catch((error) => {
          console.error("❌ SignalR Start Failed", error);
          onError(error);
        });

      return connection;
    })
    .catch((error) => {
      console.error("❌ Negotiate Failed", error);
      onError(error);
    });

  function negotiate() {
    return httpCollection.get("notificationservice", `negotiate`, {});
  }
};
